var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function ArrowsIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M56.004 20.5L67.987 8.426a2 2 0 012.833-.005l53.765 53.765a2 2 0 010 2.828L70.82 118.778a2 2 0 01-2.833-.005l-11.983-12.076",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M43.818 8.42a2 2 0 00-2.834.005l-10.58 10.662a2 2 0 00.006 2.822l40.275 40.276a2 2 0 010 2.828L30.41 105.288a2 2 0 00-.006 2.823l10.58 10.662a2 2 0 002.834.005l53.764-53.765a2 2 0 000-2.828L43.818 8.42z",
      fill: "#009CEB",
      stroke: "#009CEB",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.915 8.417a2 2 0 00-2.83-.001l-10.67 10.67a2 2 0 000 2.829l40.269 40.27a2 2 0 010 2.828l-40.27 40.27a2 2 0 000 2.828l10.671 10.671a2 2 0 002.83-.001l53.67-53.77a2 2 0 000-2.825l-53.67-53.77z",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))
  }));
}

export default ArrowsIllustration;